import { ComponentTokens, DesignToken, getComponentToken } from '@optimus-web/common';
import { CheckboxProps } from './Checkbox';

type Variant = 'checked' | 'unChecked';
type State = 'disabled' | 'error' | 'default';

const getCheckboxState = (props: Pick<CheckboxProps, 'checked' | 'disabled' | 'error' | 'indeterminate'>) => {
    const variant: Variant = props?.checked || props?.indeterminate ? 'checked' : 'unChecked';
    let state: State = 'default';

    if (props?.disabled) {
        state = 'disabled';
    } else if (props?.error) {
        state = 'error';
    }

    return { variant, state };
};

const checkboxTokens = {
    backgroundColor: {
        default: {
            checked: {
                disabled: 'backgroundDisabled',
                error: 'backgroundInteractiveDangerDefault',
                default: 'backgroundInteractivePrimaryDefault',
            },
            unChecked: {
                disabled: 'inherit',
                error: 'inherit',
                default: 'inherit',
            },
        },
        hover: {
            checked: {
                disabled: 'borderDisabled',
                error: 'backgroundInteractiveDangerHover',
                default: 'backgroundInteractivePrimaryHover',
            },
            unChecked: {
                disabled: 'inherit',
                error: 'backgroundInteractiveNeutralSubtleHover',
                default: 'backgroundInteractiveNeutralSubtleHover',
            },
        },
        active: {
            checked: {
                disabled: 'borderDisabled',
                error: 'backgroundInteractiveDangerActive',
                default: 'borderInteractivePrimaryActive',
            },
            unChecked: {
                disabled: 'borderDisabled',
                error: 'backgroundInteractiveNeutralSubtleActive',
                default: 'backgroundInteractiveNeutralSubtleActive',
            },
        },
    },
    borderColor: {
        default: {
            checked: {
                disabled: 'borderDisabled',
                error: 'backgroundInteractiveDangerDefault',
                default: 'backgroundInteractivePrimaryDefault',
            },
            unChecked: {
                disabled: 'borderDisabled',
                error: 'backgroundInteractiveDangerDefault',
                default: 'borderInteractiveSecondaryDefault',
            },
        },
        hover: {
            checked: {
                disabled: 'borderDisabled',
                error: 'backgroundInteractiveDangerHover',
                default: 'backgroundInteractivePrimaryHover',
            },
            unChecked: {
                disabled: 'borderDisabled',
                error: 'backgroundInteractiveDangerHover',
                default: 'borderInteractiveSecondaryHover',
            },
        },
        active: {
            checked: {
                disabled: 'borderDisabled',
                error: 'backgroundInteractiveDangerActive',
                default: 'borderInteractivePrimaryActive',
            },
            unChecked: {
                disabled: 'borderDisabled',
                error: 'backgroundInteractiveDangerActive',
                default: 'borderInteractiveSecondaryActive',
            },
        },
    },
} satisfies ComponentTokens<Variant, State, DesignToken | 'inherit'>;

export const getCheckboxToken = getComponentToken(checkboxTokens, getCheckboxState);
